// extracted by mini-css-extract-plugin
export var industrySectionCard = "education-card-module--industry-section-card--W+r86";
export var industrySectionCardText = "education-card-module--industry-section-card-text--uEjg8";